import request from '../../../helpers/request';
import { createFormDataFile } from '../utils/createFormDataFile';

const addAttachmentToFlat = async (addressId, file, data, typeId) => {
  const formData = new FormData();

  const validFile = createFormDataFile(file.originFileObj);

  const validData = JSON.stringify(data);

  formData.append('file', validFile);
  formData.append('data', validData);

  return await request.post(
    `/HousingStock/address/${addressId}/attachment?typeId=${typeId}`,
    formData,
    'При загрузке документа произошла ошибка'
  );
};

export default addAttachmentToFlat;
